import React, { useState } from 'react'
import TextField from '@mui/material/TextField'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { useInput, useTranslate } from 'react-admin'
import 'dayjs/locale/es';

export const DateTimePickers = ({ label, source, validate, disabled, onChange, minDateTime, maxDateTime }) => {
  const translate = useTranslate()
  const [errorDate, setErrorDate] = useState('')
  const { field, fieldState } = useInput({source, validate})
  const { error } = fieldState

  const onChangeField = (value) => {
    field.onChange(value)
    onChange && onChange(value)
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
      <DateTimePicker
        className='datePicker'
        disabled={disabled}
        onChange={onChangeField}
        value={field.value || null}
        label={label}
        renderInput={(params) => {
          params.error = error?.message || errorDate !== ''
          return <TextField helperText={!disabled ? (error?.message || errorDate) : ''} {...params} />
        }}
        minDateTime={minDateTime}
        maxDateTime={maxDateTime}
        onError={(e) => {
          if (e === null) return setErrorDate('')
          if (e === 'minDate' || e === 'minTime') return setErrorDate(translate('ra.validation.date_min'))
          if (e === 'maxDate' || e === 'maxTime') return setErrorDate(translate('ra.validation.date_max'))
          if (e === 'invalidDate') return setErrorDate(translate('ra.validation.date_invalid'))
        }}
      />
      </LocalizationProvider>
    </>
  )
}
